class NSSPDPIngredients extends HTMLElement {

    constructor() {
        super();

        this.debug = false;

        this.swiper;


    }

    connectedCallback() {
        if (this.debug) console.log("[NSS][Carousel] Connected.");

        window.whenSwiperReady(() => this.initCarousel());


        const editorEvents = [
            `shopify:inspector:activate`,
            `shopify:inspector:deactivate`,
            `shopify:section:load`,
            `shopify:section:unload`,
            `shopify:section:select`,
            `shopify:section:deselect`,
            `shopify:section:reorder`,
            `shopify:block:select`,
            `shopify:block:deselect`,
        ]
        editorEvents.forEach((event) => {
            this.addEventListener(event, this.handleEditorEvent.bind(this));
        });
    }


    initCarousel() {
        this.carouselEl = this.querySelector(`.js-nss-swiper`);
        this.carouselNavigation = this.querySelectorAll(`.js-nss-swiper-navigation`);
        this.allSettings = {

            loop: false,
            centeredSlides: false,
            slidesPerView: 1,
            direction: "horizontal",
            autoHeight: false,
            effect: "fade",
            // autoplay: {
            //     delay: 5000,
            //     waitForTransition: false,
            //     disableOnInteraction: false
            // },
            a11y: {
                enabled: true,
            },

            grabCursor: false,
        }

        this.swiper = new Swiper(this.carouselEl, this.allSettings);
        this.swiper.on('slideChange', swiper => {
            this.carouselNavigation.forEach((item, index) => {
                if (index == swiper.activeIndex) {
                    item.classList.add('is-active');
                } else {
                    item.classList.remove('is-active');
                }
            });
        });
        this.carouselNavigation.forEach((item) => {
            item.addEventListener('click', (e) => {
                this.swiper?.slideTo(parseInt(item.getAttribute('data-index'), 10));
            });
        });

    }

    handleEditorEvent(e) {
        if (this.debug) console.log("[NSS][Carousel] Handle editor event, e:", e);

        switch (e.type) {

            case `shopify:block:select`:
                const blockEl = e.detail.blockId ? this.querySelector(`[data-block-id="${e.detail.blockId}"]`) : null;
                const slideEl = blockEl?.closest(`.swiper-slide`);
                if (this.debug) console.log("[NSS][Carousel] slideEl:", slideEl);
                if (slideEl) {
                    // const index = slideEl.getAttribute(`data-swiper-slide-index`);
                    const slideEls = [...this.querySelectorAll(`.swiper-slide`)];
                    const index = slideEls.indexOf(slideEl);
                    if (this.debug) console.log("[NSS][Carousel] Sliding to index:", index);
                    this.swiper.slideTo(index);
                }
                break;

        }
    }
}

let elementName = `nss-pdp-ingredients`;
if (typeof customElements.get(elementName) === `undefined`) {
    customElements.define(elementName, NSSPDPIngredients);
}